export const FETCHING_REPORT = 'FETCHING_REPORT';
export const FETCH_REPORT_SUCCESS = 'FETCH_REPORT_SUCCESS';
export const FETCHING_REPORTS_TEMPLATES = 'FETCHING_REPORTS_TEMPLATES';
export const FETCH_REPORTS_TEMPLATES_SUCCESS = 'FETCH_REPORTS_TEMPLATES_SUCCESS';
export const GENERATING_REPORT = 'GENERATING_REPORT';
export const GENERATE_REPORT_SUCCESS = 'GENERATE_REPORT_SUCCESS';
export const DOWNLOADING_REPORT = 'DOWNLOADING_REPORT';
export const DOWNLOAD_REPORT_SUCCESS = 'DOWNLOAD_REPORT_SUCCESS';


// WEBPACK FOOTER //
// ./src/redux/report/ReportConstants.js